import { PrivacyPolicy } from './index'

const routes = [
  {
    path: '/privacy',
    name: 'Privacy Policy',
    authenticated: false,
    render(props) {
      return <PrivacyPolicy {...props} />
    }
  }
]

export { routes }
